<template>
	<div>
		<myheader headTitle="更改签章人"></myheader>
		<div class="all_list_main">
			<div class="horizontal_flex" style="background-color: white;">
				<div style="width: 49.9%;">
					<div class="all_height_line22 text14 textcolor333 all_text_center backgroundC_white bwhite_ative"
						:style="{color:isSigner==='true'?listFlag?'#0277FC':'#333':'#bcbcbc'}"
						@click="selectFlag(true)">签字人
					</div>
					<div style="height: 2px;background-color: #0277FC;"
						:style="{'background-color':listFlag? '#0277FC':'#cccccc'}"></div>
				</div>
				<div class="vertical_line all_height_line24"></div>
				<div style="width: 49.9%;">
					<div class="all_height_line22 text14 textcolor333 all_text_center backgroundC_white bwhite_ative"
						:style="{color:isSealer==='true'?!listFlag?'#0277FC':'#333':'#bcbcbc'}"
						@click="selectFlag(false)">盖章人
					</div>
					<div style="height: 2px;" :style="{'background-color':!listFlag? '#0277FC':'#cccccc'}"></div>
				</div>
			</div>
			<div class="all_list_content_nopadding" style="padding-bottom: 3.5rem;top:6.3rem">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div style="min-height: 70vh;height: auto;" v-show="list.length>0">
						<div v-for="(item,index) in list" :key="index" class="backgroundC_white"
							@click="selectIndex(item,index)">
							<div class="flex" style="height: 3rem;padding: 0 .5rem;">
								<img src="@/assets/images/signsealer.svg" style="height:2rem;margin: .5rem;" />
								<span class="text14 textcolor333 font_weight_700 all_height_line14"
									style="display: inline-block;width:70%;margin: .8rem 0;">{{item.staffName}}</span>
								<img v-if="listFlag?index ===signIndex:index===sealIndex"
									src="@/assets/images/selected.svg" style="height: .8rem;margin: 1.1rem;" />
							</div>
							<div class="horizontal_line"></div>
						</div>
					</div>
					<van-empty style="margin-top: 20vh;" description="暂无数据" v-show="list.length==0" />
				</van-pull-refresh>
			</div>
			<div class="all_tips_bottom_card">
				<button class="all_button24 width_100 text16" @click="sumbit()">确定</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,
		PullRefresh
	} from "vant";
	//Vue.use(Empty).use(PullRefresh);
	export default {
		components: {
			[Empty.name]: Empty,
			[PullRefresh.name]: PullRefresh,
		},
		data() {
			return {
				//true 签名人，false盖章人
				listFlag: true, 
				//签章人列表
				list: [],
				//是否刷新
				refreshing: false,
				//签署企业列表中corps数据Id
				corpsId: '', 
				//合同id
				contractId: '', 
				// 企业id
				corpsCorpId: '', 
				//是否签名人
				isSigner: true,
				//是否盖章人
				isSealer: true,
				//选中签名人index
				signIndex: -1,
				//选中盖章人index
				sealIndex: -1,
				//选中签名人
				signItem: null,
				//选中盖章人
				sealItem: null,
			}
		},
		methods: {
			//提交修改签证人
			sumbit() {
				let url = ''
				let param = ''
				if (this.listFlag) {
					url = '/contract/api/modifyContractSigner'
					param = JSON.stringify({
						id: this.corpsId,
						corpId: this.corpsCorpId,
						contractId: this.contractId,
						signerCode: this.signItem.userName,
						signerName: this.signItem.staffName
					})
				} else {
					url = '/contract/api/modifyContractSealer'
					param = JSON.stringify({
						id: this.corpsId,
						corpId: this.corpsCorpId,
						contractId: this.contractId,
						sealerCode: this.sealItem.userName,
						sealerName: this.sealItem.staffName
					})
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post(url, param).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast('更改成功！')
						this.$router.go(-1)
					} else {
						this.$Toast(res.message || '更改失败，请重试！')
					}
				});
			},
			//选中签章人人
			selectIndex(item, index) {
				if (this.listFlag) {
					this.signIndex = index
					this.signItem = item
				} else {
					this.sealIndex = index
					this.sealItem = item
				}
			},
			//初始化状态
			init() {
				this.contractId = this.$route.query.contractId
				this.corpsCorpId = this.$route.query.corpsCorpId
				this.corpsId = this.$route.query.corpsId
				this.isSigner = this.$route.query.isSigner
				this.isSealer = this.$route.query.isSealer
				// console.log(this.isSigner.constructor )
				// console.log(this.isSealer.constructor)
				if ('false' === this.isSigner) {
					//console.log('isSigner')
					this.listFlag = false
				}
				if (this.isSealer) {
					//console.log('isSealer')
				}
				//console.log('listFlag--'+this.listFlag)
				this.getList()
			},
			//下拉刷新
			onRefresh() {
				if (this.refreshing) {
					this.list = []
					this.refreshing = false
				}
				this.getList()
			},
			//获取签名人和盖章人列表
			getList() {
				let url = ''
				if (this.listFlag) {
					url = '/contract/api/getCorpSealers/' + this.corpsId
				} else {
					url = '/contract/api/getCorpSigners/' + this.corpsId
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post(url).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.list = res.data.newItems
					}
				});
			},
			//切换签名人和盖章人
			selectFlag(flag) {
				if ((this.isSigner === 'false' && flag) || (this.isSealer === 'false' && !flag)) {
					return
				}
				if (this.listFlag != flag) {
					this.listFlag = flag
					this.refreshing = true
					this.onRefresh()
				}
			},
		},
		mounted() {
			this.init()
		},
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>